/**
 * Temporary file store for passing large files between CurationTool and SyncView
 * without using sessionStorage (which has size limits).
 *
 * Files are stored in memory and cleared when retrieved.
 */

interface StoredFile {
  name: string;
  file: File;
}

const fileStore: Map<string, StoredFile> = new Map();

/**
 * Store a file temporarily for sync navigation
 */
export function storeFileForSync(key: string, name: string, file: File): void {
  fileStore.set(key, { name, file });
}

/**
 * Retrieve a stored file (does not remove it - call clearSyncFileStore when done)
 * Note: We don't delete on retrieval because React Strict Mode can cause
 * useEffect to run twice, which would fail on the second retrieval.
 */
export function retrieveFileForSync(key: string): StoredFile | null {
  const stored = fileStore.get(key);
  return stored || null;
}

/**
 * Clear all stored files (for cleanup)
 */
export function clearSyncFileStore(): void {
  fileStore.clear();
}
